import FormattedMessage from 'I18n/components/FormattedMessage';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Link } from 'foundations-components/transitional/components/Link';
import { BookIcon, LessonIcon, ListsIcon, WebsiteIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Fragment, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HUBSPOT_USER_GUIDE_LINK_THEME = 'https://knowledge.hubspot.com/website-pages/use-themes';
const HUBSPOT_USER_GUIDE_LINK_MODULE = 'https://knowledge.hubspot.com/website-pages/edit-page-content-in-a-drag-and-drop-area';
const NoopExternalIcon = () => null;
export default function AssetResources({
  casesUrl,
  forumUrl,
  getAssetEventSelectorId = () => '',
  offeringType = 'THEME',
  onTrackInteraction,
  setupUrl,
  supportUrl
}) {
  const trackInteraction = useCallback(value => {
    if (onTrackInteraction) {
      onTrackInteraction(value);
    }
  }, [onTrackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-assets-core.details.resources.title"
      })
    }), /*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(LessonIcon, {}), /*#__PURE__*/_jsx(Link, {
            ExternalIcon: NoopExternalIcon,
            external: true,
            "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-SETUP-GUIDE'),
            href: setupUrl,
            onClick: () => trackInteraction('click setup guide link'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-assets-core.details.resources.setupUrl"
            })
          })]
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(LessonIcon, {}), /*#__PURE__*/_jsx(Link, {
            ExternalIcon: NoopExternalIcon,
            external: true,
            href: offeringType === 'THEME' ? HUBSPOT_USER_GUIDE_LINK_THEME : HUBSPOT_USER_GUIDE_LINK_MODULE,
            onClick: () => trackInteraction('click user guide link'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-assets-core.details.resources.userGuide"
            })
          })]
        })
      }), supportUrl && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(WebsiteIcon, {}), /*#__PURE__*/_jsx(Link, {
            ExternalIcon: NoopExternalIcon,
            external: true,
            "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-SUPPORT-WEBSITE'),
            href: supportUrl,
            onClick: () => trackInteraction('click support website link'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-assets-core.details.resources.supportUrl"
            })
          })]
        })
      }), forumUrl && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(ListsIcon, {}), /*#__PURE__*/_jsx(Link, {
            ExternalIcon: NoopExternalIcon,
            external: true,
            "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-COMMUNITY'),
            href: forumUrl,
            onClick: () => trackInteraction('click community link'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-assets-core.details.resources.forumUrl"
            })
          })]
        })
      }), casesUrl && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(BookIcon, {}), /*#__PURE__*/_jsx(Link, {
            ExternalIcon: NoopExternalIcon,
            external: true,
            "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-CASE-STUDY'),
            href: casesUrl,
            onClick: () => trackInteraction('click case study link'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-assets-core.details.resources.casesUrl"
            })
          })]
        })
      })]
    })]
  });
}